// extracted by mini-css-extract-plugin
export default {"navbar":"navbar_navbar__ItcLZ","user":"navbar_user__UMxLN","data":"navbar_data__eGI80","name":"navbar_name__Blp7R","company":"navbar_company__IgL2d","image":"navbar_image__WMdQE"};